<template>
  <div class="dashboard">
    <!-- Header Section -->
    <div class="header-section">
      <h1 class="greeting">
        Welcome back, <span class="user-name">{{ user.name }}</span>
      </h1>
      <p class="subtitle">Here's your system overview for today</p>
    </div>
    <div class="section-container" v-if="permissions.allowGeneralStats">
      <general-stats></general-stats>
    </div>

    <!-- Stats Cards -->
    <div class="section-container mt-5" v-if="permissions.allowServerStats">
      <server-stats />
    </div>

    <!-- Coming Soon Section -->
    <b-card no-body class="feature-card my-5">
      <b-card-body
        class="d-flex flex-column flex-md-row justify-content-between align-items-center"
      >
        <div class="text-content mb-3 mb-md-0">
          <h3 class="feature-title">✨ New Features Coming Soon!</h3>
          <p class="feature-text mb-0">
            We're working on improvements to enhance your experience.
          </p>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import GeneralStats from "../components/Dashboard/GeneralStats.vue";
import ServerStats from "../components/Dashboard/ServerStats.vue";

export default {
  components: {
    GeneralStats,
    ServerStats,
  },
  data() {
    return {
      storageData: {
        totalGB: 58,
        freeGB: 50,
        usedGB: 8,
        usedPercentage: 13,
      },
      chartData: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    permissions() {
      return this.$store.state.user.permissions;
    },
    currentDate() {
      const options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      return new Date().toLocaleDateString(undefined, options);
    },
  },
};
</script>

<style scoped>
.dashboard {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #f8f9fe;
  border-radius: 5px;
}

.header-section {
  margin-bottom: 2.5rem;
}

.greeting {
  font-size: 2rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.user-name {
  color: #4e73df;
}

.subtitle {
  color: #6c757d;
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .greeting {
    font-size: 1.5rem;
  }

  .header-section {
    margin-bottom: 1.5rem;
  }
}

.section-container {
  background-color: #ffffff;
  padding: 1.5rem;
  padding-left: 0;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease, transform 0.2s ease;
  border: 1px solid #f1f3f5;
}

.section-container:hover {
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.feature-card {
  border: none;
  border-radius: 10px;
  background-color: #f8f9fe;
}

.feature-title {
  color: #4e73df;
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}

.feature-text {
  color: #5a5c69;
}
</style>
